import { createPortal } from 'react-dom';
import { ReactPortalElementId } from 'core/layouts';
import { FixedInsights } from './FixedInsights';
import { CustomInsights } from './CustomInsights';
import {
  BehaviorInsightsContentWrapper,
  RatePanelsWrapper,
  InsightsSectionWrapper,
} from './BehaviorInsights.styled';
import { ConversionRatePanel } from './ConversionRatePanel';
import { UnsubscribeRatePanel } from './UnsubscribeRatePanel';
import { BehaviorInsightsActions } from './BehaviorInsightsActions';
import { BehaviorInsightsContextProvider } from '../../../contexts/behaviorInsights';

export const BehaviorInsights = () => {
  const portalPath = document.getElementById(
    ReactPortalElementId.sementationInsightsToolbarActions,
  );

  return (
    <BehaviorInsightsContextProvider>
      <BehaviorInsightsContentWrapper>
        {portalPath && createPortal(<BehaviorInsightsActions />, portalPath)}
        <RatePanelsWrapper>
          <ConversionRatePanel />
          <UnsubscribeRatePanel />
        </RatePanelsWrapper>
        <InsightsSectionWrapper>
          <FixedInsights />
          <CustomInsights />
        </InsightsSectionWrapper>
      </BehaviorInsightsContentWrapper>
    </BehaviorInsightsContextProvider>
  );
};
